// extracted by mini-css-extract-plugin
export var cardIcon = "_73-5";
export var checkboxCard = "_73-0";
export var checkboxCardSelected = "_73-4";
export var disabled = "_73-2";
export var interactive = "_73-1";
export var outerBorder = "_73-3";
export var spacerMedium = "_73-8";
export var spacerSmall = "_73-7";
export var spacerXsmall = "_73-6";